import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';


@Component({
  selector: 'ppl-auth-message',
  standalone: false,
  templateUrl: './auth-message.component.html',
  styleUrl: './auth-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthMessageComponent {
  @Input() label: string;
  @Input() message: string;
  @Input() actionVisible = true;
  @Input() actionLabel: string;
  @Input() icon = 'logout-restriction';

  @Input() showIcon = true;

  @Output() action = new EventEmitter();

  onActionClick() {
    this.action.emit();
  }
}
